import { extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
  colors: {
    brand: {
      50: '#fff5f5',
      100: '#fed7d7',
      200: '#feb2b2',
      300: '#fc8181',
      400: '#f56565',
      500: '#e53e3e', // Color principal
      600: '#c53030',
      700: '#9b2c2c',
      800: '#822727',
      900: '#63171b',
    },
  },
  components: {
    Card: {
      baseStyle: {
        container: {
          borderRadius: '2xl',
          boxShadow: 'xl',
          transition: 'all 0.3s ease',
          border: '2px solid',
          borderColor: 'transparent',
          overflow: 'hidden',
          position: 'relative',
          _before: {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '4px',
            bgGradient: 'linear(to-r, brand.400, brand.500, brand.600)',
            transition: 'transform 0.3s ease',
            transform: 'scaleX(0)',
            transformOrigin: 'left',
          },
        },
      },
      variants: {
        elevated: {
          container: {
            _hover: {
              transform: 'translateY(-4px)',
              boxShadow: '2xl',
              borderColor: 'brand.100',
              _before: {
                transform: 'scaleX(1)',
              },
            },
          },
        },
      },
    },
    Heading: {
      baseStyle: {
        color: 'brand.500',
      },
    },
  },
})

export default theme
